// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ccAC2","requiredAsterisk":"Info_requiredAsterisk__1VFqM"};